import { ActionTree } from 'vuex';
import {TournamentState, TournamentActions, TournamentMutations, StartLoading, TournamentRequest} from './types';
import { RootState } from '../types';
import {tournamentsApi} from '@/api/TournamentsApi';

export const actions: ActionTree<TournamentState, RootState> = {
  async [TournamentActions.StartLoading]({ commit }, payload: StartLoading) {
    commit(TournamentMutations.StartLoading);
    const requests = await tournamentsApi.getTournamentRequests(payload.tournamentId).toPromise();
    commit(TournamentMutations.InitTournament, {
      requests,
      tournamentId: payload.tournamentId,
      forumThreadId: payload.forumThreadId,
    });
    commit(TournamentMutations.FinishLoading);
  },
  async [TournamentActions.ApproveRequest]({ commit, state }, requestId: string) {
    const index = state.requests.findIndex((x: TournamentRequest) => x.id === requestId);
    const request = state.requests[index];
    commit(TournamentMutations.ClearHttpErrors);
    try {
      await tournamentsApi.updateTournamentRequest(
        state.forumThreadId as number, +request.id, request.organizerComment, true).toPromise();
      commit(TournamentMutations.ApproveRequest, requestId);
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.error(e);
      commit(TournamentMutations.HttpError);
    }
  },
  async [TournamentActions.RejectRequest]({ commit, state }, requestId: string) {
    const index = state.requests.findIndex((x: TournamentRequest) => x.id === requestId);
    const request = state.requests[index];
    commit(TournamentMutations.ClearHttpErrors);
    try {
      await tournamentsApi.updateTournamentRequest(
        state.forumThreadId as number, +request.id, request.organizerComment, false).toPromise();
      commit(TournamentMutations.ApproveRequest, requestId);
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.error(e);
      commit(TournamentMutations.HttpError);
    }
  },
};
